export const EFileStatusTypes = {
	completed: 'COMPLETED',
	failed: 'FAILED',
} as const;
